import { useDrawer } from '@flecto/ui'

import { DrawerCustomer, type DrawerCustomerProps } from './DrawerCustomer'

export function useDrawerCustomer(props?: DrawerCustomerProps) {
  return useDrawer(
    <DrawerCustomer
      setCustomer={props?.setCustomer}
      customer={props?.customer}
    />
  )
}
